import 'styled-components/macro';
import 'scroll-shadow-element';
import { HTMLAttributes, useState } from 'react';
import tw from 'twin.macro';

import {
  AssignmentMarkdown,
  AssignmentMarkdownProps,
} from 'component-lib/molecules/assignment-markdown/AssignmentMarkdown';
import { Tab, Tabs } from 'component-lib/molecules/tabs/Tabs';
import { ShadowScrollContainer } from 'play/molecules/shadow-scroll-container/ShadowScrollContainer';
import { ChecksCreation } from 'play/organisms/checks-creation/ChecksCreation';
import { LearnEnvironmentQuery } from 'types/graphql';

const tabStyles = [tw`text-white font-normal pb-0 w-1/2 justify-center`];
const tabActiveStyles = tw`font-medium border-tertiary! border-b-4`;

enum AssignmentTab {
  Assignment = 'Assignment',
  Checks = 'Checks',
}

interface Props {
  challenge: NonNullable<LearnEnvironmentQuery['challenge']>;
  onAccordionToggle: AssignmentMarkdownProps['onToggle'];
}

export const AssignmentChecksCreationMode = ({ challenge, onAccordionToggle }: Props) => {
  const [activeTab, setActiveTab] = useState(AssignmentTab.Assignment);

  return (
    <>
      <Tabs css={tw`p-2 pb-0 justify-center`}>
        {Object.values(AssignmentTab).map(tab => (
          <Tab
            key={tab}
            value={tab}
            active={activeTab === tab}
            onClick={() => setActiveTab(tab)}
            css={[tabStyles, [activeTab === tab && tabActiveStyles]]}
          >
            {tab}
          </Tab>
        ))}
      </Tabs>
      <ShadowScrollContainer>
        <TabContent activeValue={activeTab} value={AssignmentTab.Assignment}>
          <AssignmentMarkdown title={challenge.title} value={challenge.assignment} onToggle={onAccordionToggle} />
        </TabContent>

        <TabContent activeValue={activeTab} value={AssignmentTab.Checks}>
          <ChecksCreation challenge={challenge} />
        </TabContent>
      </ShadowScrollContainer>
    </>
  );
};

export interface TabContentProps extends HTMLAttributes<HTMLDivElement> {
  value: AssignmentTab;
  activeValue: AssignmentTab;
}

const TabContent = ({ value, activeValue, children }: TabContentProps) => (
  <div role="tabpanel" id={`tabpanel-${value}`} aria-labelledby={`tab-${value}`} hidden={value !== activeValue}>
    {children}
  </div>
);
